import LocalStorage from '../Services/LocalStorage'

const API_BASE_URL = 'https://ems.tecnelmc.cloud:3030'
// const API_BASE_URL = 'https://209.227.237.153:3030'
// const API_BASE_URL = 'http://localhost:3030'
// const API_BASE_ADDR = 'https://ems.tecnelmc.com'

const Config = {
  STORAGE_KEY: 'EMSTECNEL',
  API_BASE_URL,
  apiUrl: API_BASE_URL, // Alias per compatibilità con i componenti
  appVersion: require('../../package.json').version,
  format
}

function format (value) {
  if (value === null || value === undefined || value === '') {
    return '0,00 €'
  }

  const numericValue = parseFloat(value)
  if (isNaN(numericValue)) {
    return value
  }

  try {
    // Prova a ottenere la valuta dal LocalStorage usando la funzione LocalStorage
    const user = LocalStorage.get('user')
    const currencySymbol = user?.azienda?.valuta || '€'

    // Se la valuta è un simbolo personalizzato (non un codice ISO), usa formatSimple
    if (currencySymbol.length <= 3 && !['EUR', 'USD', 'GBP', 'CHF', 'JPY'].includes(currencySymbol)) {
      return formatSimple(numericValue, currencySymbol)
    }

    // Mappa dei simboli ai codici valuta ISO
    const currencyMap = {
      '€': 'EUR',
      $: 'USD',
      '£': 'GBP',
      CHF: 'CHF',
      '¥': 'JPY'
    }

    const currencyCode = currencyMap[currencySymbol] || 'EUR'

    // Usa Intl.NumberFormat con locale italiano per formato: 100.000,00 €
    const formatter = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    return formatter.format(numericValue)
  } catch (error) {
    // Fallback in caso di errore
    return formatSimple(numericValue, '€')
  }
}

function formatSimple (value, currencySymbol = '€') {
  if (value === null || value === undefined || value === '') {
    return `0,00 ${currencySymbol}`
  }

  const numericValue = parseFloat(value)
  if (isNaN(numericValue)) {
    return value
  }

  // Formatta il numero con separatore delle migliaia (.) e decimali (,)
  // Esempio: 100000 -> 100.000,00
  const parts = numericValue.toFixed(2).split('.')
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const decimalPart = parts[1]

  return `${integerPart},${decimalPart} ${currencySymbol}`
}

export default Config
